import { useState } from "react";
import { Copy, Check, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export const CXOEmail = ({ email = {} }) => {
  const [copied, setCopied] = useState(false);

  const fullText = `Subject: ${email.subject || ""}\n\n${email.body || ""}`;

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(fullText);
      setCopied(true);
      toast.success("Email copied to clipboard");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Copy failed");
    }
  };

  return (
    <div className="bg-[#141414] border border-[#262626] rounded-sm" data-testid="cxo-email-card">
      <div className="flex items-center justify-between px-5 py-3 border-b border-[#262626]">
        <div className="flex items-center gap-3">
          <div className="w-7 h-7 rounded-sm border border-[#262626] bg-[#0A0A0A] flex items-center justify-center">
            <Mail className="w-3.5 h-3.5 text-[#0A84FF]" strokeWidth={1.7}/>
          </div>
          <div>
            <div className="kpi-label">/ DRAFT · CXO OUTREACH</div>
            <div className="text-xs text-[#737373] mt-0.5 font-mono-data">To: {email.to_role || "Senior CXO"}</div>
          </div>
        </div>
        <Button
          type="button"
          onClick={onCopy}
          data-testid="copy-cxo-email-btn"
          className="h-9 rounded-sm bg-transparent hover:bg-[#1F1F1F] text-white border border-[#262626] hover:border-[#404040] gap-2 transition-colors"
        >
          {copied ? <Check className="w-3.5 h-3.5 text-[#32D74B]"/> : <Copy className="w-3.5 h-3.5"/>}
          <span className="text-xs font-mono-data tracking-wider uppercase">{copied ? "Copied" : "Copy"}</span>
        </Button>
      </div>
      <div className="p-5 space-y-3">
        <div>
          <div className="kpi-label mb-1">Subject</div>
          <div className="text-base text-white font-display tracking-tight">{email.subject || "—"}</div>
        </div>
        <div>
          <div className="kpi-label mb-1">Body</div>
          <div className="text-sm text-[#E5E5E5] leading-relaxed whitespace-pre-wrap" data-testid="cxo-email-body">
            {email.body || "—"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CXOEmail;
